import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=26fa2efa&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=26fa2efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa2efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fa2efa')) {
      api.createRecord('26fa2efa', component.options)
    } else {
      api.reload('26fa2efa', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=26fa2efa&scoped=true&", function () {
      api.rerender('26fa2efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KPVStl1Lffwx/JS/comp/CookieBox.vue"
export default component.exports